// @store-module
import { Module } from "vuex";
import { initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

interface FileManagementState {
  fileManagement: boolean;
  resource: string;
  resource_id: string;
  attachment_temp_code: Array<object>;
}

const fileManagementStore: Module<any, FileManagementState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default fileManagementStore;
